import { de } from "vuetify/lib/locale";

export default {
  $vuetify: { ...de },
  ...de,
  // Navigation
  navigation: {
    plantsCare: "Pflanzenpflege",
    shop: "Shop",
    collection: "Kollektion",
  },

  // Header
  header: {
    // Static navigation menu
    menu: {
      assortment: "Sortiment",
      aboutHappyPlants: "Über Happy Plants",
      inspiration: "Inspiration",

      homePage: {
        header: "Startseite",
        title: "Startseite",
      },
      CollectionPage: {
        header: "Alle Produkte",
        title: "Alle Produkte",
      },
      caringPlants: {
        header: "Pflanzenpflege",
        title: "Prinzipien der Pflanzenpflege",
      },
      ourCompany: {
        header: "Unser Unternehmen & B2B",
        title: "Unser Unternehmen & B2B",
      },
      santinoSystem: {
        header: "Santino Pflanzenpflege-System",
        title: "Pflanzenpflege-System",
      },
      Contact: {
        header: "Kontakt",
        title: "Kontaktieren Sie uns",
      },
      selfWatering: {
        header: "Selbstbewässernde Töpfe",
        title: "Santino Selbstbewässerungs-System",
      },
      sustainability: {
        header: "Nachhaltigkeit",
        title: "Nachhaltigkeit",
      },
      blog: {
        header: "Ratschläge & Tipps für alle Pflanzenliebhaber",
        title: "Lesen Sie unseren Blog",
      },
      inspireTopics: {
        header: "Lassen Sie sich von relevanten Themen inspirieren",
      },
    },

    // Dynamic category menu
    categories: {
      allProducts: "Alle Produkte",
      loading: "Kategorien werden geladen...",
      shoppingCart: "Warenkorb",
      goToCart: "Zum Warenkorb",
    },

    // Aria labels for accessibility
    aria: {
      logoLink: "Link zur Startseite",
      searchToggle: "Suche umschalten",
      menuToggle: "Navigationsmenü umschalten",
    },
  },

  // Mobile menu (drawer)
  mobileDrawer: {
    // Window titles
    title: {
      main: "Hauptmenü",
    },

    // Main menu
    menu: {
      home: "Startseite",
      assortment: {
        title: "Sortiment",
        items: {
          allProducts: "Alle Produkte",
          shoppingCart: "Warenkorb",
        },
      },
      about: {
        title: "Über Happy Plants",
        items: {
          aboutUs: "Über uns & B2B",
          sustainability: "Nachhaltigkeit",
          plantCare: "Prinzipien der Pflanzenpflege",
          santinoSystem: "Santino Selbstbewässerungs-System",
          blog: "Lesen Sie unseren Blog",
        },
      },
      inspiration: {
        title: "Inspiration",
      },
      contact: "Kontakt",
    },

    // Secondary menu items
    secondary: {
      terms: "Allgemeine Geschäftsbedingungen",
      privacy: "Datenschutz",
    },

    // Footer
    footer: {
      whatsapp: "WHATS APP",
      b2b: "B2B",
      contact: "KONTAKTIEREN SIE UNS",
    },
  },

  // Search
  searchField: {
    label: "Produkte suchen",
    searching: "Produkte werden gesucht...",
    untitledProduct: "Unbenanntes Produkt",

    // Search results
    results: {
      title: "Suchergebnisse ({count})",
      sku: "SKU",
      currency: "EUR",
    },

    // No results
    noResults: {
      title: "Keine Ergebnisse gefunden",
      subtitle: 'Versuchen Sie, Ihre Suchbegriffe für "{query}" anzupassen',
    },

    // Recent searches
    recent: {
      title: "Letzte Suchanfragen",
    },

    // Popular searches (examples)
    popular: {
      selfWatering: "Selbstbewässernder Topf",
      indoorPlants: "Zimmerpflanzen",
      flowerPots: "Blumentöpfe",
      plantCare: "Pflanzenpflege",
      decorativePots: "Dekorative Töpfe",
      outdoorPlanters: "Außenpflanzgefäße",
    },

    // Error
    error: "Fehler bei der Suche",
  },

  // Shopping cart
  shoppingCart: {
    ariaLabel: "Warenkorb",
    title: "Ihr Warenkorb",
    loading: "Produkte werden geladen...",
    empty: "Ihr Warenkorb ist leer",
    subtotal: "Zwischensumme:",
    currency: "EUR",
    checkoutNote: "Der endgültige Preis wird nach dem Checkout angezeigt",
    placeOrder: "Bestellung aufgeben",
    minimumOrder: "mind. EUR",
  },

  // Home page
  home: {
    subtitle: "Seit über +16 Jahren produzieren wir",
    headline: {
      part1: "Außergewöhnliche Blumentöpfe",
      part2: "mit Selbstbewässerungssystem",
      part3: "die sich um Ihre Pflanzen kümmern",
      part4: "und",
      water: "Wasser sparen",
    },
    buttons: {
      plantCare: "Pflanzenpflege",
      shop: "Shop",
    },
    // Categories section
    categories: {
      title: "Entdecken Sie unser Produktsortiment",
      subtitle: "Smarte Töpfe für schöne Blüten",
      shopAll: "Alle kaufen",
      loading: "Kategorien werden geladen...",
    },
    // Popular products
    popularProducts: {
      title: "Beliebteste Produkte",
      subtitle: "Bestseller für mühelose Pflanzenpflege",
      seeAll: "Alle Produkte ansehen",
    },
    // Special offers
    saleOffers: {
      title: "Sonderangebote",
      subtitle: "Bestseller für mühelose Pflanzenpflege",
      seeAll: "Alle Produkte ansehen",
    },
    // Pots technology
    potsTechnology: {
      subtitle: "Unsere Topftechnologie",
      title: {
        part1: "Warum haben",
        plants: "Pflanzen",
        part2: "Probleme?",
        part3: "Wie wir einen",
        smarter: "intelligenteren",
        part4: "Weg entwickelt haben,",
        helpThemThrive: "damit sie gedeihen",
      },
      buttons: {
        plantCare: "Pflanzenpflege-Technologie",
        shop: "Shop",
      },
    },
    // Root problem
    rootProblem: {
      title: "Was macht Ihre Pflanzen traurig?",
      paragraph1: {
        part1: "Selbst die schönsten",
        highlight: "Zimmerpflanzen können Probleme haben, wenn ihre Grundbedürfnisse nicht erfüllt werden.",
        part2: "Und meistens kommt das Problem von einer Sache - dem Gießen.",
      },
      paragraph2: "Egal ob Sie Hobbygärtner oder erfahrener Pflanzenprofi sind, diese Herausforderungen können zu einer Sache führen: einer ungesunden Pflanze.",
      solutionSubtitle: "Unsere innovative Lösung für gesunde Pflanzen",
      solutionTitle: "Deshalb haben wir den Blumentopf neu erfunden.",
      solutionText: "Pflanzen gedeihen nicht durch gute Absichten. Sie brauchen die richtige Menge Wasser zur richtigen Zeit. Aber sich zu merken, wer was und wann braucht? Damit haben die meisten Pflanzenliebhaber Probleme.",
    },
    // Santino system
    santinoSystem: {
      subtitle: "Santino Pflanzenpflege-System™",
      title: {
        part1: "Im Herzen jedes Happy Plants Blumentopfs steckt das",
        systemName: "Santino Pflanzenpflege-System",
        part2: "— unsere charakteristische Selbstbewässerungstechnologie,",
      },
    },
    // Smart plants
    smartPlants: {
      section1: {
        title: "Der intelligente Weg zu glücklichen Pflanzen",
        text: {
          part1: "Egal ob Sie Anfänger, Enthusiast oder Pflanzenprofi sind,",
          highlight: "Happy Plants nimmt den Stress aus der Pflanzenpflege.",
        },
      },
      section2: {
        title: "Die Pflanzen werden bei Bedarf mit Wasser versorgt",
        text: {
          part1: "Mit dem",
          systemName: "Santino Pflanzenpflege-System",
          part2: "als Kern lösen unsere selbstbewässernden Blumentöpfe die häufigsten Probleme, damit Ihre Pflanzen gedeihen können und Sie auch.",
        },
      },
    },
    // Benefits
    benefits: {
      title: "Wie profitieren Ihre geliebten Pflanzen von den selbstbewässernden Töpfen des Santino Pflanzenpflege-Systems?",
      options: {
        twinPot: {
          title: "Doppeltopf",
          subtitle: "Zwei Kammern arbeiten harmonisch zusammen",
          features: {
            doublePot: {
              title: "Doppelter Blumentopf",
              text: "Der Übertopf und der Pflanztopf: Sie erleichtern die Pflege und bieten weitere Vorteile",
            },
            lessWater: {
              title: "Mit weniger Wasser",
              text: "Um den Wasserstand einfach zu überwachen (für nicht transparente Töpfe)",
            },
            hecticSchedule: {
              title: "Eine großartige Lösung für einen hektischen Zeitplan",
              text: "Genießen Sie bequemes Gießen ohne Auslaufen dank des inneren Wassertanks",
            },
          },
        },
        healthyRoots: {
          title: "Gesunde Wurzeln — Gesundes Wachstum",
          subtitle: "Ein wurzelzentrierter Ansatz, der dauerhafte Vitalität von innen heraus fördert.",
          features: {
            moistureProtection: {
              title: "Wurzelschutz vor überschüssiger Feuchtigkeit",
              text: "Der Doppeltopf mit dem Wassertank unter den Wurzeln der Pflanze trägt zur Gesundheit der Wurzeln bei und schützt vor Wasserstau",
            },
            airCushion: {
              title: "Schützendes Luftpolster",
              text: "Der Doppeltopf erzeugt ein Luftpolster, das Wärmeisolierung bietet und Unterkühlung des Wurzelsystems oder Austrocknung der Erde verhindert",
            },
            soilAeration: {
              title: "Optimales Wachstum und Bodenbelüftung",
              text: "Die Drainagelöcher des Innentopfs ermöglichen Luftzirkulation im Boden und tragen so zur Gesundheit der Pflanzen bei",
            },
          },
        },
        aesthetics: {
          title: "Herausragende Ästhetik, erhabenes Design",
          subtitle: "Ein Topf, der genauso schön ist wie die Pflanzen, die er unterstützt",
          features: {
            cleanCozy: {
              title: "Sauber und gemütlich",
              text: "Der Topf und die Oberflächen bleiben sauber: keine Verschüttungen oder Schmutzspuren",
            },
            visualControl: {
              title: "Sichtbares Kontrollfenster",
              text: "Um den Wasserstand einfach zu überwachen (für nicht transparente Töpfe)",
            },
            saucerFree: {
              title: "Ohne Untersetzer",
              text: "Genießen Sie bequemes Gießen ohne Auslaufen dank des inneren Wassertanks",
            },
          },
        },
        savingWater: {
          title: "Wasser & Zeit sparen",
          subtitle: "Durchdacht entwickelt, um die Gießhäufigkeit zu reduzieren — mehr Ruhe, weniger Rätselraten.",
          features: {
            lessFrequent: {
              title: "Pflanzen werden seltener gegossen",
              text: "Der Topf und die Oberflächen bleiben sauber: keine Verschüttungen oder Schmutzspuren",
            },
            innerReservoir1: {
              title: "Inneres Reservoir",
              text: "Das Reservoir und die Drainagelöcher befinden sich im Topf, unter dem Niveau der Wurzeln",
            },
            innerReservoir2: {
              title: "Inneres Reservoir",
              text: "Das Reservoir und die Drainagelöcher befinden sich im Topf, unter dem Niveau der Wurzeln",
            },
          },
        },
      },
    },
    // Water is life
    waterIsLife: {
      title: "Wasser ist Leben, wenn es richtig verwendet wird.",
      subtitle: "Über unsere Selbstbewässerungstechnologie",
      text: {
        paragraph1: "Jede Pflanze hat einzigartige Bedürfnisse.",
        paragraph2: "Der Schlüssel ist Beständigkeit, nicht Rätselraten.",
        paragraph3: "Pflanzen gedeihen nicht durch gute Absichten — sie brauchen die richtige Menge Wasser zur richtigen Zeit. Aber sich zu merken, wer was und wann braucht? Damit haben die meisten Pflanzenliebhaber Probleme.",
      },
    },
    // Water details
    waterDetails: {
      section1: {
        title: "Wir haben den Blumentopf neu erfunden",
        text: "Die Pflanzen werden bei Bedarf mit Wasser versorgt – wann immer sie es brauchen, in der Menge, die sie brauchen.",
      },
      section2: {
        title: "Konstante Feuchtigkeit. Kein Rätselraten mehr.",
        text: 'Unsere selbstbewässernden Töpfe sind mit einem eingebauten Wasserreservoir an der Basis ausgestattet. Sie nutzen die Kapillarwirkung, auch bekannt als "Dochtwirkung", um Wasser nach oben in die Erde zu ziehen, wenn die Pflanze es braucht. Dieser natürliche Prozess stellt sicher, dass Ihre Pflanze immer Zugang zur richtigen Menge an Feuchtigkeit hat.',
        benefits: {
          noOverwatering: "Kein Übergießen mehr",
          noUnderwatering: "Kein Untergießen mehr",
          happyPlants: "Glückliche Pflanzen mit weniger Aufwand",
        },
      },
      section3: {
        title: "Über die Selbstbewässerungstechnologie",
        text: "Egal ob Sie Pflanzen-Neuling oder erfahrener Gärtner sind, unser Selbstbewässerungssystem nimmt den Stress aus der täglichen Pflanzenpflege.",
        features: {
          upgrade: {
            title: "Das Upgrade",
            text: "Unsere Self-Watering+ Serie bringt mühelose Pflanzenpflege auf die nächste Stufe. Jeder Topf in dieser Serie verfügt entweder über ein Textil-Dochtsystem oder eine innovative Seramis® Keramik-Drainage-Kartusche — ein in Deutschland entwickeltes Hochleistungsmaterial, das sicherstellt, dass Ihre Pflanzen genau die richtige Menge Wasser erhalten.",
          },
          soilMoisture: {
            title: "Optimale Bodenfeuchtigkeit",
            text: "Wenn Pflanzenwurzeln Wasser aus dem Boden aufnehmen, ermöglicht das eingebaute Reservoir unter ihnen dem Boden, bei Bedarf zusätzliche Feuchtigkeit aufzunehmen — für konstante, optimale Luftfeuchtigkeit für gesundes Wachstum.",
          },
        },
      },
    },
    // Shop water
    shopWater: {
      cards: {
        selfWatering: {
          title: "Selbstbewässernd",
          text: "Egal ob Sie Pflanzen-Neuling oder erfahrener Gärtner sind, unser Selbstbewässerungssystem nimmt den Stress aus der täglichen Pflanzenpflege.",
        },
        selfWateringPlus1: {
          title: "Selbstbewässernd+",
          text: "Doppeltopf mit Docht für optimale Bodenfeuchtigkeit. Entwickelt für Orchideenliebhaber",
        },
        selfWateringPlus2: {
          title: "Selbstbewässernd+",
          text: "Doppeltopf mit SERAMIS® Pflanzengranulat-Kartusche für hohe Wasser- und Nährstoffspeicherung.",
        },
      },
      shopNow: "Jetzt kaufen",
    },
    // More explore
    moreExplore: {
      title: "Mehr zu entdecken",
      subtitle: "Schließen Sie sich Hunderten von Profis weltweit an, die Happy Plants bereits vertrauen.",
      cards: {
        shopNew: {
          title: "Neue Modelle kaufen",
          text: "Entdecken Sie unsere neuesten selbstbewässernden Pflanzgefäße und modernen Topfdesigns für jedes Zuhause, Büro und Geschäftsraum.",
          button: "Jetzt kaufen",
        },
        aboutSystem: {
          title: "Über das Selbstbewässerungs-System",
          text: "Unsere innovative Selbstbewässerungstechnologie hält Pflanzen über einen langen Zeitraum perfekt hydratisiert.",
          button: "Erkunden",
        },
        plantsCare: {
          title: "Pflanzenpflege-System",
          text: "Happy Plants fördert die Gesundheit der Pflanzen durch Design: Belüftung, Feuchtigkeitsbalance und richtige Drainage.",
          button: "Erkunden",
        },
        sustainability: {
          title: "Nachhaltigkeit",
          text: "Alle Produkte von Happy Plants werden aus recycelbaren Materialien hergestellt, um Abfall zu reduzieren und die Nachhaltigkeit zu fördern",
          button: "Erkunden",
        },
      },
    },
  },

  // Collection page
  collection: {
    header: {
      title: "Entdecken Sie unser Produktsortiment",
      titleWithCategory: "Kollektion",
      subtitle: "Jeder Topf, einzigartig gefertigt. Sorgfältig entworfen, durchdacht entwickelt — jeder gemacht, um Ihren Pflanzen (und Ihnen) zu helfen, zu gedeihen.",
      breadcrumbs: {
        home: "Startseite",
        allCollections: "Alle Kollektionen",
      },
    },

    filters: {
      search: "Suchen",
      appliedFilters: "Angewendete Filter:",
      total: "Gesamt:",
      products: "Produkte",
      advicesAndTips: "Ratschläge und Tipps",
      sortBy: "Sortieren nach",
      sortOptions: {
        priceLowHigh: "Preis von 0-100",
        priceHighLow: "Preis von 100-0",
        nameAZ: "Name A-Z",
        nameZA: "Name Z-A",
      },
      filtersTitle: "Filter",

      filterTypes: {
        potSize: "Topfgröße",
        potType: "Topfart",
        potShape: "Topfform",
        exteriorColor: "Außenfarbe",
        functionality: "Funktionalität",
      },

      functionality: {
        waterControl: "Wasserkontrollfenster",
        bottomPlug: "Bodenstopfen zum Ablassen",
        indoor: "Für drinnen",
        outdoor: "Für draußen",
        semiTransparent: "Halbtransparent",
        orchids: "Für Orchideen",
        windowBox: "Fensterkasten",
      },

      loading: "Produkte werden geladen...",
      noResults: "Keine Produkte gefunden",
      clearFilters: "Filter löschen",
      loadMore: "Mehr laden",
      retry: "Wiederholen",
    },

    recentlyViewed: {
      title: "Sie haben kürzlich angesehen",
      subtitle: "Kürzlich von Ihnen überprüftes Sortiment.",
    },
  },

  // Product page
  product: {
    breadcrumbs: {
      home: "Startseite",
      allCollections: "Alle Kollektionen",
    },

    details: {
      skuNumber: "Nr. SKU",
      readFullDescription: "Vollständige Beschreibung lesen",
      potType: "Topfart",
      potShape: "Topfform",
      dimensions: "Abmessungen (cm)",
      availableColors: "Verfügbare Außenfarben",
      addToCart: "In den Warenkorb",

      quantity: {
        label: "Menge",
      },

      messages: {
        addedToCart: "Produkt erfolgreich in den Warenkorb gelegt!",
      },

      payment: {
        title: "Online-Zahlungen kommen bald.",
        description: "Sie können jedoch noch eine Bestellanfrage über die Website aufgeben. Sobald Ihre Anfrage eingereicht wurde, wird sich ein Verkaufsleiter in Kürze mit Ihnen in Verbindung setzen, um die Details zu bestätigen und die Zahlung zu arrangieren. Mehr erfahren unter",
        link: "Bestellung aufgeben und Lieferung",
      },
    },

    description: {
      title: "Produktbeschreibung",
      dimensionsTitle: "Produktabmessungen",
      faqTitle: "Ihre Fragen, beantwortet",

      faq: {
        question1: {
          title: "Ist es nicht schwierig, sich um Orchideen zu kümmern?",
          text: "Nicht mit unserem Selbstbewässerungssystem — es hält die Wurzeln auf dem richtigen Niveau hydratisiert ohne tägliches Gießen.",
        },
        question2: {
          title: "Passt der Topf zu meiner Einrichtung?",
          text: "Absolut — jeder Arte-Dea Topf ist mit klaren, eleganten Linien entworfen, die jeden Raum ergänzen.",
        },
        question3: {
          title: "Was ist, wenn ich vergesse zu gießen?",
          text: "Keine Sorge — das eingebaute Reservoir versorgt Ihre Orchidee tagelang mit einer stetigen Feuchtigkeitsversorgung, sodass Ihre Pflanze gesund bleibt, auch wenn Sie beschäftigt sind.",
        },
      },
    },

    otherProducts: {
      title_part_1: "Mehr aus der",
      title_part_2: "Kollektion",
      subtitle: "Suchen Sie nach einem passenden Stil? Entdecken Sie unten weitere Stücke aus derselben Kollektion.",
    },
  },

  // Principles page
  principles: {
    breadcrumbs: {
      home: "Startseite",
      principles: "Prinzipien der Pflanzenpflege",
    },

    header: {
      title: "Prinzipien der Pflanzenpflege",
      subtitle: "Hilfe für diejenigen, die sich um Pflanzen kümmern. Sanfte Richtlinien für Gärtner und Pflanzenliebhaber.",
    },

    forWhom: {
      title: "Für wen sind Happy Plants Töpfe?",
      subtitle: "Fünf Arten von Pflanzenliebhabern und Gärtnern, die mit unseren Töpfen und Pflege gedeihen",
      types: {
        newParents: "Neue Pflanzeneltern",
        experienced: "Erfahrene Gärtner",
        indoor: "Indoor-Lifestyle-Enthusiasten",
        lovers: "Blumen- und Pflanzenliebhaber",
        gifters: "Geschenkkäufer",
      },
    },

    sevenPrinciples: {
      mainTitle: "Santino Prinzipien für gesunde Pflanzen",
      mainSubtitle: "Lieferung hochwertiger Pflanzenpflegeprodukte mit neuen Konzepten",
      shopButton: "Alle Töpfe kaufen",
      bottomTitle: "Für die Umsetzung aller 7 Pflanzenpflege-Prinzipien haben wir außergewöhnliche Blumentöpfe entworfen",

      principles: {
        alive: {
          title: "Pflanzen sind lebendig",
          text: 'Eine Pflanze ist ein lebender Organismus — sie wächst, atmet, transpiriert und benötigt Wasser, Nährstoffe, Licht, die richtige Umgebung und die richtige Temperatur. Sie muss auch umgetopft werden, kann sich vermehren und — wie wir — gedeihen oder leiden, sich "glücklich" fühlen oder Anzeichen von Stress zeigen.',
        },
        unique: {
          title: "Jede Pflanze ist einzigartig",
          text: "Jede Pflanze ist einzigartig, aber jede braucht die richtigen Bedingungen für Wachstum und Schutz. Dazu gehört eine personalisierte Pflegeroutine: Gießen, Düngen, Behandlung und Gesundheitsüberwachung — alles nach ihrem eigenen natürlichen Rhythmus.",
        },
        soil: {
          title: "Verwenden Sie die richtige Erde",
          text: "Verwenden Sie ein geeignetes Substrat — angemessene Erde, Drainagematerial, Werkzeuge und Dünger, die auf die spezifischen Bedürfnisse Ihrer Pflanze zugeschnitten sind.",
        },
        pot: {
          title: "Wählen Sie den richtigen Topf",
          text: "Wählen Sie den richtigen Topf — Größe, Form, Funktionalität und sogar Farbe können das Wohlbefinden einer Pflanze beeinflussen.",
        },
        water: {
          title: "Nicht übergießen",
          text: "Die meisten Pflanzen mögen keine überschüssige Feuchtigkeit. Übergießen kann zu Wurzelfäule führen, besonders bei nicht-hydrophytischen Arten. Sorgen Sie für ordnungsgemäße Drainage, besonders bei Außentöpfen, um die Wurzeln gesund zu halten.",
        },
        heat: {
          title: "Vermeiden Sie Hitzestress",
          text: "Pflanzen sind anfällig für Hitzestress. Extreme Temperaturen — zu heiß oder zu kalt — können Boden, Wasser und Luft um die Pflanze herum austrocknen und ihr Wachstum und ihre Entwicklung behindern.",
        },
        love: {
          title: "Lieben Sie Ihre Pflanzen",
          text: "Bewundern und lieben Sie Ihre Pflanzen! Geben Sie ihnen Aufmerksamkeit, Pflege und Geduld. Im Gegenzug werden sie Sie mit Schönheit, Vitalität und einem tiefen Gefühl von Freude und Erfüllung belohnen.",
        },
      },
    },

    gradient: {
      selfWatering: {
        title: "Selbstbewässerung für konstante Feuchtigkeit",
        text: "Happy Plants Töpfe verfügen über ein eingebautes Wasserreservoir und ein Kapillar-Dochtsystem, das dem Boden bei Bedarf Wasser zuführt. Dieses intelligente Reservoir beseitigt Rätselraten und verhindert sowohl Über- als auch Untergießen",
      },
      healthyRoots: {
        title: "Gesunde Wurzeln dank optimaler Belüftung",
        text: "Das Doppeltopf-Design erzeugt ein Luftpolster um die Wurzelzone. Drainagelöcher und ein inneres Reservoir schützen die Wurzeln vor stehendem Wasser und Fäulnis und sorgen gleichzeitig für frische Luft",
      },
      cleanDesign: {
        title: "Sauberes, zeitsparendes Design, das Wasser spart",
        text: "Diese Töpfe sind ohne Untersetzer und haben ein Fenster zum Überprüfen des Wasserstands, halten Oberflächen sauber und vermeiden Wasserflecken.",
      },
    },

    callToAction: {
      title: "Bereit, Ihre Pflanzen glücklicher zu machen?",
      text: "Entdecken Sie unser gesamtes Sortiment an selbstbewässernden Happy Plants Töpfen und geben Sie Ihren grünen Freunden die Pflege, die sie verdienen.",
      button: "Alle Töpfe kaufen",
    },
  },

  // Plants Care System page
  plantsCareSystem: {
    breadcrumbs: {
      home: "Startseite",
      system: "Pflanzenpflege-System",
    },

    header: {
      title: "Pflanzenpflege-System",
      subtitle: "Intelligent. Stilvoll. Gemacht für das echte Leben",
    },

    heart: {
      title: "Im Herzen jedes Happy Plants Blumentopfs",
      text: "Das Santino Pflanzenpflege-System — ist unsere charakteristische Selbstbewässerungstechnologie, die alle Happy Plants Funktionen zusammenbringt, die entwickelt wurden, um Pflanzen gesund und Pflanzenliebhaber glücklich zu halten.",
      button: "Pflanzenpflege-Töpfe kaufen",
    },

    allInOne: {
      title: "All-in-One Pflegelösung",
      text: "Das Santino Pflanzenpflege-System™ bringt alle Happy Plants™ Funktionen zusammen, die entwickelt wurden, um Pflanzen gesund und Pflanzenliebhaber glücklich zu halten.",
      button: "Jetzt kaufen",

      features: {
        feature1: "Neue Pflanzeneltern",
        feature2: "Integriertes Selbstbewässerungssystem für stetige, konstante Hydratation",
        feature3: "Sichtbarer Wasserstandsanzeiger — nie wieder über- oder untergießen",
        feature4: "Verbesserte Luftzirkulation zum Schutz der Wurzeln und zur Verhinderung von Fäulnis",
        feature5: "Wartungsarmes Design perfekt für modernes, geschäftiges Leben",
      },
    },

    selfWatering: {
      title: "Selbstbewässerungstechnologie als Teil des Pflanzenpflege-Systems",
      subtitle: "Egal ob Sie Pflanzen-Neuling oder erfahrener Gärtner sind, unser Selbstbewässerungssystem nimmt den Stress aus der täglichen Pflanzenpflege.",
      button: "Selbstbewässerung erkunden",

      upgrade: {
        title: "Das Upgrade",
        text: "Unsere Self-Watering+ Serie bringt mühelose Pflanzenpflege auf die nächste Stufe. Jeder Topf in dieser Serie verfügt entweder über ein Textil-Dochtsystem oder eine innovative Seramis® Keramik-Drainage-Kartusche — ein in Deutschland entwickeltes Hochleistungsmaterial, das sicherstellt, dass Ihre Pflanzen genau die richtige Menge Wasser erhalten.",
      },

      moisture: {
        title: "Optimale Bodenfeuchtigkeit",
        text: "Wenn Pflanzenwurzeln Wasser aus dem Boden aufnehmen, ermöglicht das eingebaute Reservoir unter ihnen dem Boden, bei Bedarf zusätzliche Feuchtigkeit aufzunehmen — für konstante, optimale Luftfeuchtigkeit für gesundes Wachstum.",
      },
    },
  },

  // Sustainability page
  sustainability: {
    breadcrumbs: {
      home: "Startseite",
      sustainability: "Nachhaltigkeit",
    },

    intro: {
      title: "Jede große Veränderung beginnt mit einem einfachen Schritt",
      paragraph1: "Bei Happy Plants glauben wir, dass jeder Blumentopf eine Geschichte hat und diese Geschichte nicht enden muss, wenn der Topf reißt, verblasst oder nicht mehr benötigt wird.",
      paragraph2: "Durch CycleBloom, unseren internen Recyclingprozess, geben wir gebrauchten Töpfen ein zweites Leben und verwandeln die Materialien von gestern in die schönen, funktionalen Designs von morgen.",
      paragraph3: "Es ist unsere Art, die Natur zu schützen, Abfall zu reduzieren und eine Zukunft aufzubauen, in der Nachhaltigkeit und Stil Hand in Hand gehen.",
    },

    process: {
      step1: {
        title: "Sammlung, Wiedergewinnung & Sortierung nach Farbe",
        text: "Wir beginnen damit, gebrauchte oder beschädigte Blumentöpfe von Kunden, Einzelhändlern, aus der Produktion und von Partnern nach Farbe zu sammeln und zu sortieren. Diese werden zurückgewonnen und für ein neues Leben vorbereitet, anstatt auf Deponien zu landen.",
      },
      step2: {
        title: "Zerkleinern & Mahlen",
        text: "Sortierte Töpfe werden dann in kleine, gleichmäßige Flocken zerkleinert — bis zu 10 mm Größe. Diese Flocken sind ideal für die weitere Verarbeitung und konsistentes Schmelzverhalten beim Formen.",
      },
      step3: {
        title: "Verpackung & Lagerung",
        text: "Das zerkleinerte Material wird in großen Industriesäcken gelagert, wobei jede Farbcharge sauber und organisiert gehalten wird, bis es Zeit für die Produktion ist.",
      },
      step4: {
        title: "Formen zu neuen Töpfen",
        text: "Mit traditionellen thermoplastischen Formmaschinen verwandeln wir das recycelte Material in brandneue Blumentöpfe. Kein Neumaterial wird hinzugefügt — 100% recyceltes PP wird verwendet.",
      },
    },

    result: {
      title: "Das Ergebnis?",
      paragraph1: "Eine neue Generation von Blumentöpfen: stark, stilvoll und nachhaltig. Jeder ist vollständig aus recyceltem Material hergestellt und ist wieder vollständig recycelbar.",
      paragraph2: "Es ist mehr als nur ein Topf — es ist Teil einer zirkulären Zukunft, in der Schönheit auf Verantwortung trifft.",
    },
  },

  // Self-Watering System page
  selfWateringSystem: {
    breadcrumbs: {
      home: "Startseite",
      selfWatering: "Selbstbewässerungs-System",
    },

    header: {
      title: "Selbstbewässerungs-System",
      subtitle: "Intelligent. Stilvoll. Gemacht für das echte Leben",
    },

    whatIs: {
      title: "Was ist Selbstbewässerung?",
      text: 'Viele Pflanzenliebhaber stehen vor diesem Problem: Wie sorgt man für ein gleichmäßiges Feuchtigkeitsniveau für jede grüne Begleitung? Pflanzen leben nicht „nach Gefühl“ — sie brauchen eine konstante Menge Wasser zum richtigen Zeitpunkt. Doch sich zu merken, wann und wie viel jedes Töpfchen Wasser braucht, ist nicht einfach. Deshalb haben wir den Blumentopf neu gedacht: Unser Happy Plants-Topf mit Selbstbewässerungssystem nimmt das Rätselraten ab und macht die Pflege einfacher.',
      button: "Erkunden",
    },

    allInOne: {
      title: "Diese All-in-One Pflegelösung",
      text: 'Das Hauptmerkmal der Selbstbewässerung ist ein eingebautes Wasserreservoir an der Basis. Durch ein dochtartiges Kapillarsystem steigt Wasser allmählich zu den Wurzeln und versorgt die Pflanzen "auf Abruf" mit Feuchtigkeit.',
      features: {
        feature1: "Konstante Feuchtigkeit ohne Rätselraten. Der große Innenbehälter sorgt für eine gleichmäßige Wasserversorgung.",
        feature2: "Wurzelschutz. Die doppelwandige Struktur erzeugt ein Luftpolster, das Wurzelfäule und Unterkühlung verhindert.",
        feature3: "Weniger Gießvorgänge. Der innere Tank hält die Pflanze lange Zeit hydratisiert.",
        feature4: "Sauber und bequem. Die Töpfe benötigen keine Untersetzer und enthalten ein kleines Fenster zur Überprüfung des Wasserstands (für undurchsichtige Modelle).",
        feature5: "Wartungsarmes Design perfekt für modernes, geschäftiges Leben",
      },
      button: "Jetzt kaufen",
    },

    reimagined: {
      title: "Wir haben den Blumentopf neu erfunden",
      text: "Die Pflanzen werden bei Bedarf mit Wasser versorgt – wann immer sie es brauchen, in der Menge, die sie brauchen.",
    },

    consistentMoisture: {
      title: "Konstante Feuchtigkeit. Kein Rätselraten mehr.",
      text: 'Unsere Selbstbewässerungstöpfe sind mit einem integrierten Wasserreservoir im Boden ausgestattet. Sie nutzen die Kapillarwirkung, auch „Dochtprinzip“ genannt, um Wasser durch die Abflusslöcher des Innentopfs nach oben in die Erde zu ziehen – genau dann, wenn die Pflanze es braucht. Dieser natürliche Prozess sorgt dafür, dass deine Pflanze stets die richtige Menge Feuchtigkeit erhält. Ein weiterer Vorteil ist die Belüftung der Erde, die den Wurzeln und der allgemeinen Gesundheit der Pflanze zugutekommt.',
      benefits: {
        noOverwatering: "Kein Übergießen mehr",
        noUnderwatering: "Kein Untergießen mehr",
        happyPlants: "Glückliche Pflanzen mit weniger Aufwand",
      },
    },
  },

  // Hashtag page
  hashtag: {
    breadcrumbs: {
      home: "Startseite",
      hashtag: "Hashtag #",
    },

    header: {
      description: "Hier ist alles, was Sie finden können über",
      byHappyPlants: "von HappyPlants",
    },

    relevantProducts: {
      title: "Relevante Produkte",
      subtitle: "Entdecken Sie die Produkte, die relevant sind für #",
    },

    relevantArticles: {
      title: "Relevante Artikel",
      subtitle: "Entdecken Sie die Artikel, die relevant sind für #",
    },
  },

  // Contact Us page
  contactUs: {
    header: {
      title: "Kontakt",
      subtitle: "Bei HappyPlants ist Ihre Zufriedenheit unsere Priorität. Wenn Sie etwas brauchen, sind wir immer hier, um zu helfen.",
    },

    sections: {
      headOffice: "Hauptsitz",
      phone: "Telefon",
      email: "E-Mail",
      companyDetails: "Firmendetails",
    },

    form: {
      firstName: {
        label: "Vorname",
        placeholder: "Name",
      },
      lastName: {
        label: "Nachname",
        placeholder: "Nachname",
      },
      email: {
        label: "Ihre E-Mail",
        placeholder: "E-Mail",
      },
      phone: {
        label: "Telefon (optional)",
        placeholder: "+373 XX XXX XXX",
      },
      topic: {
        label: "Thema",
        placeholder: "Wählen Sie eine Option",
      },
      message: {
        label: "Ihre Nachricht",
        placeholder: "Schreiben Sie Ihre Nachricht hier",
      },
      submitButton: "Senden!",
    },

    validation: {
      required: "Dieses Feld ist erforderlich",
      invalidEmail: "Ungültige E-Mail-Adresse",
    },

    messages: {
      success: "Ihre Nachricht wurde erfolgreich gesendet!",
      error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    },

    defaultTopics: {
      general: "Allgemeine Frage",
      partnership: "Partnerschaft",
      pricing: "Preisgestaltung",
      other: "Andere",
    },
  },

  // Blog page
  blog: {
    breadcrumbs: {
      home: "Startseite",
      blog: "Happy Plants Blog",
    },

    header: {
      title: "Happy Plants Blog",
      subtitle: "Einblicke, Tipps und Inspiration für Pflanzenliebhaber",
    },
  },

  // About Us & B2B page
  aboutB2B: {
    breadcrumbs: {
      home: "Startseite",
      aboutB2B: "Über uns & B2B Zusammenarbeit",
    },

    header: {
      title: "Über uns & B2B Zusammenarbeit",
      subtitle: "Blumentöpfen ein neues Leben geben.",
    },

    weAre: {
      title: "Wir sind Happy Plants",
      subtitle: "ein europäischer Hersteller von verkaufsfertigen selbstbewässernden Pflanzgefäßen mit einer nachgewiesenen Erfolgsbilanz bei der Lieferung von margenstarken, schnell umschlagenden Produkten an große Einzelhändler und Distributoren weltweit.",
    },

    customersWant: {
      title: "Ihre Kunden wollen mehr als nur Blumentöpfe.",
      text: "Sie wollen Bequemlichkeit, Eleganz und Lösungen, die Zeit und Wasser sparen — und wir machen das möglich.",
    },

    whyWorkWithUs: {
      title: "Warum mit uns arbeiten",
      features: {
        provenSeller: "Bewährter Verkäufer — Unsere selbstbewässernden Pflanzgefäße sind bereits erfolgreich auf den US- und EU-Einzelhandelsmärkten, sowohl unter unserer Marke als auch als Handelsmarke.",
        retailReady: "Verkaufsfertig — Jedes Produkt kommt verpackt, mit Barcode versehen und bereit für Ihre Regale.",
        designThatSells: "Design, das verkauft — Attraktive, funktionale Designs fördern Impulskäufe und Wiederholungsverkäufe.",
        cleanConvenient: "Sauber und bequem. Die Töpfe benötigen keine Untersetzer und enthalten ein kleines Fenster zur Überprüfung des Wasserstands (für undurchsichtige Modelle).",
        highProfitMargins: "Hohe Gewinnmargen — Stapelbare, platzsparende Konstruktion bedeutet niedrigere Versand- und Lagerkosten und steigert Ihren Gewinn.",
      },
      button: "Jetzt kaufen",
    },

    ourEdge: {
      title: "Unser Vorteil",
      features: {
        fullCycle: "Vollzyklus-Fertigung — Von der Konzeptgestaltung bis zur endgültigen Verpackung, alles in unserer eigenen Fabrik in Moldawien.",
        capacity: "Kapazität, auf die Sie zählen können — 150.000 Pflanzgefäße pro Monat, konstante Qualität und pünktliche Lieferungen.",
        designSells: "Design, das verkauft — Attraktive, funktionale Designs fördern Impulskäufe und Wiederholungsverkäufe.",
        ecoResponsible: "Umweltverantwortlich — Wir verwenden sowohl recycelte als auch neue Kunststoffe und erfüllen Nachhaltigkeitsziele ohne Kompromisse bei der Qualität.",
        logistics: "Logistik ohne Kopfschmerzen — DDP/DDU-Lieferung in die USA in 40 Tagen; etablierte, zuverlässige Versandpartner.",
      },
      button: "Jetzt kaufen",
    },

    productsFit: {
      title: "Produkte, die zu Ihrem Markt passen",
      features: {
        indoorOutdoor: "Selbstbewässernde Pflanzgefäße für drinnen & draußen",
        orchidPots: "Premium-Orchideentöpfe mit wasserabsorbierendem Docht",
        decorativeOptions: "Modelle mit Ständern & dekorativen Optionen",
        multipleOptions: "Mehrere Formen, Größen und Farben — bereit für Ihre Handelsmarke",
      },
      button: "Jetzt kaufen",
    },

    opportunity: {
      title: "Die Chance",
      paragraph1: 'Wir helfen Einzelhändlern, den Kategorieumsatz zu steigern und das wachsende "Convenience Gardening"-Segment mit lagerfertigen, verkaufsfertigen Pflanzgefäßen zu erweitern.',
      paragraph2: "Egal, ob Sie Ihr Gartensortiment erweitern, eine saisonale Aktion starten oder eine exklusive Handelsmarkenlinie kreieren möchten — wir haben das Angebot, die Qualität und die Erfahrung, um zu liefern.",
    },

    contactForm: {
      title: "Lassen Sie uns über Ihre Sortimentziele sprechen.",
      contact: {
        title: "Kontakt",
      },
      sections: {
        headOffice: "Hauptsitz",
        phone: "Telefon",
        email: "E-Mail",
      },
      form: {
        firstName: {
          label: "Vorname",
          placeholder: "Name",
        },
        lastName: {
          label: "Nachname",
          placeholder: "Nachname",
        },
        email: {
          label: "Ihre E-Mail",
          placeholder: "E-Mail",
        },
        phone: {
          label: "Telefon (optional)",
          placeholder: "+373 XX XXX XXX",
        },
        topic: {
          label: "Thema",
          placeholder: "Wählen Sie eine Option",
        },
        message: {
          label: "Ihre Nachricht",
          placeholder: "Schreiben Sie Ihre Nachricht hier",
        },
        submitButton: "Senden!",
      },
      validation: {
        required: "Dieses Feld ist erforderlich",
        invalidEmail: "Ungültige E-Mail-Adresse",
      },
      messages: {
        success: "Ihre Nachricht wurde erfolgreich gesendet!",
        error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      },
      defaultTopics: {
        general: "Allgemeine Frage",
        partnership: "Partnerschaft",
        pricing: "Preisgestaltung",
        other: "Andere",
      },
    },
  },

  // Blog Article page
  blogArticle: {
    breadcrumbs: {
      home: "Startseite",
      blog: "Happy Plants Blog",
    },
    title: "Happy Plants Blog",
    subtitle: "Einblicke, Tipps und Inspiration für Pflanzenliebhaber",
  },

  // Explore Hashtags component
  exploreHashtags: {
    title: "Weitere Happy Plants Hashtags erkunden",
  },

  // Shopping Cart page
  shoppingCartPage: {
    title: "Ihr Warenkorb",
    subtitle: "Sobald wir Ihre Anfrage erhalten, überprüft unser Manager die Verfügbarkeit und nimmt Kontakt mit Ihnen auf, um die Details zu bestätigen und Ihre Bestellung abzuschließen.",
    emptyCart: "Ihr Warenkorb ist leer",
    loading: "Ihr Warenkorb wird geladen...",

    volumeSize: "Volumen + Größe",
    color: "Farbe",

    quantity: "Menge",
    pot: "Topf",
    pots: "Töpfe",

    checkout: {
      title: "Zur Kasse",
      subtotalProducts: "Zwischensumme Produkte:",
      volume: "Volumen",
      minimumOrder: "Mindestbestellmenge beträgt EUR",
      currently: "aktuell EUR",
      minimumOrderWarning: "Die Mindestbestellmenge beträgt",
      termsAgreement: 'Durch Klicken auf "Bestellung aufgeben" bestätigen Sie, dass Sie die Lieferbedingungen gelesen haben und unseren Allgemeinen Geschäftsbedingungen zustimmen.',
      placeOrder: "Bestellung aufgeben",
    },

    paymentInfo: {
      title: "Online-Zahlungen kommen bald.",
      text: "Sie können jedoch noch eine Bestellanfrage über die Website aufgeben. Sobald Ihre Anfrage eingereicht wurde, wird sich ein Verkaufsleiter in Kürze mit Ihnen in Verbindung setzen, um die Details zu bestätigen und die Zahlung zu arrangieren. Mehr erfahren unter Bestellung aufgeben und Lieferung.",
    },

    removeConfirm: "Sind Sie sicher, dass Sie diesen Artikel aus Ihrem Warenkorb entfernen möchten?",
  },

  // Checkout Form
  checkoutForm: {
    title: "Zur Kasse",
    billingAddress: "Rechnungsadresse:",
    billingAddressText: "Wird für Zahlung und Rechnungszwecke verwendet. Muss mit Ihren Karten- oder Zahlungsmethodendetails übereinstimmen.",
    shippingAddress: "Lieferadresse:",
    shippingAddressText: "Wo Ihre Bestellung geliefert wird. Sie können bei Bedarf eine andere Adresse als die Rechnungsadresse verwenden.",

    emptyCart: "Ihr Warenkorb ist leer",

    minimumOrderWarning: "Mindestbestellmenge beträgt EUR",
    currentTotal: "Aktuell gesamt: EUR",

    placeOrder: "Bestellung aufgeben",
    creatingOrder: "Bestellung wird erstellt...",

    unexpectedError: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",

    orderSummary: {
      title: "Bestellübersicht",
      productsTotal: "Produkte gesamt:",
      items: "Artikel:",
      item: "Artikel",
      itemsPlural: "Artikel",
      shippingCost: "Versandkosten",
      willBeInformed: "Wird nach der Bestellung mitgeteilt",
      orderDetails: "Bestelldetails:",
    },

    paymentInfo: {
      title: "Online-Zahlungen kommen bald.",
      text: "Sie können jedoch noch eine Bestellanfrage über die Website aufgeben. Sobald Ihre Anfrage eingereicht wurde, wird sich ein Verkaufsleiter in Kürze mit Ihnen in Verbindung setzen, um die Details zu bestätigen und die Zahlung zu arrangieren. Mehr erfahren unter Bestellung aufgeben und Lieferung.",
    },
  },

  // Delivery Address Form
  deliveryAddressForm: {
    title: "Lieferadresse",

    fields: {
      email: "*E-Mail",
      emailPlaceholder: "E-Mail",
      name: "*Name",
      namePlaceholder: "Name",
      surname: "*Nachname",
      surnamePlaceholder: "Nachname",
      businessName: "Firmenname",
      businessNamePlaceholder: "Firmenname",
      addressLine1: "Adresszeile 1",
      addressLine1Placeholder: "Adresszeile 1",
      addressLine2: "Adresszeile 2",
      addressLine2Placeholder: "Adresszeile 2",
      zipCode: "*Postleitzahl",
      zipCodePlaceholder: "Postleitzahl",
      city: "*Stadt",
      cityPlaceholder: "Stadt",
      province: "*Bundesland",
      provincePlaceholder: "Bundesland",
      country: "*Land",
      countryPlaceholder: "Land auswählen",
      noteToCarrier: "Hinweis an Kurier",
      noteToCarrierPlaceholder: "Hinweis an Kurier",
      phoneNumber: "*Telefonnummer",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    validation: {
      emailRequired: "E-Mail ist erforderlich",
      emailInvalid: "E-Mail muss gültig sein",
      fieldRequired: "Feld ist erforderlich",
      minCharacters: "Mindestens 2 Zeichen",
      phoneRequired: "Telefonnummer ist erforderlich",
      phoneInvalid: "Ungültige Telefonnummer",
      zipRequired: "Postleitzahl ist erforderlich",
      zipInvalid: "Ungültige Postleitzahl",
    },

    save: "Speichern",
    changeAddress: "Adresse ändern",
    loadingCountries: "Länder werden geladen...",
    noCountries: "Keine Länder verfügbar",
  },

  // Invoice Address Form
  invoiceAddressForm: {
    title: "Rechnungsadresse",
    useSameAddress: "Dieselbe Adresse wie für die Lieferung verwenden",

    fields: {
      email: "*E-Mail",
      emailPlaceholder: "E-Mail",
      name: "*Name",
      namePlaceholder: "Name",
      surname: "*Nachname",
      surnamePlaceholder: "Nachname",
      businessName: "Firmenname",
      businessNamePlaceholder: "Firmenname",
      addressLine1: "Adresszeile 1",
      addressLine1Placeholder: "Adresszeile 1",
      addressLine2: "Adresszeile 2",
      addressLine2Placeholder: "Adresszeile 2",
      zipCode: "*Postleitzahl",
      zipCodePlaceholder: "Postleitzahl",
      city: "*Stadt",
      cityPlaceholder: "Stadt",
      province: "*Bundesland",
      provincePlaceholder: "Bundesland",
      country: "*Land",
      countryPlaceholder: "Land auswählen",
      noteToCarrier: "Hinweis an Kurier",
      noteToCarrierPlaceholder: "Hinweis an Kurier",
      phoneNumber: "*Telefonnummer",
      phoneNumberPlaceholder: "+40 78 580 4972",
    },

    validation: {
      emailRequired: "E-Mail ist erforderlich",
      emailInvalid: "E-Mail muss gültig sein",
      fieldRequired: "Feld ist erforderlich",
      minCharacters: "Mindestens 2 Zeichen",
      phoneRequired: "Telefonnummer ist erforderlich",
      phoneInvalid: "Ungültige Telefonnummer",
      zipRequired: "Postleitzahl ist erforderlich",
      zipInvalid: "Ungültige Postleitzahl",
    },

    save: "Speichern",
    changeAddress: "Adresse ändern",
    loadingCountries: "Länder werden geladen...",
    noCountries: "Keine Länder",
  },

  // Order Confirmation
  orderConfirmation: {
    thankYou: "Vielen Dank,",
    subtitle: "Ihre Pflanzen werden glücklicher sein als je zuvor",
    emailSent: "Wir haben Ihnen die Rechnung und Bestellinformationen per E-Mail gesendet",
    here: "hier",

    productsTotal: "Produkte gesamt:",
    items: "Artikel:",
    itemsCount: "Artikel",
    orderId: "Bestell-ID:",

    continueShopping: "Weiter einkaufen",
    downloadInvoiceButton: "Rechnung herunterladen",
  },

  // Order Details
  orderDetails: {
    title: "Bestelldetails:",
    volumeSize: "Volumen + Größe",
    color: "Farbe",
    productImage: "Produktbild",
    product: "Produkt",
  },

  // Tips & Ideas component
  tipsIdeas: {
    title: "Tipps, Ideen und Inspiration",
    subtitle: "Entdecken Sie intelligente Pflanzenpflege, nachhaltiges Design und die besten Wege, das Beste aus Ihren Happy Plants Töpfen zu machen.",
    readNow: "Jetzt lesen",
    hashtagsTitle: "Hashtags",
    hashtagsText: "Verwenden Sie Hashtags, um sofort verwandte Produkte, Artikel und Inspiration zu finden. Ein Klick verbindet Sie mit allem, was zählt.",
  },

  // Footer
  footer: {
    site: "Seite",
    shopHappyPlants: "Happy Plants kaufen",
    clientServiceTitle: "Kundenservice",
    menu: {
      home: "Startseite",
      shop: "Shop",
      sustainability: "Nachhaltigkeit",
      selfWatering: "Selbstbewässerung",
      careSystem: "Pflegesystem",
      blog: "Blog",
      about: "Über uns & B2B",
    },
    clientService: {
      contact: "Kontaktieren Sie uns",
      shipping: "Versand",
      terms: "Bedingungen für die Bestellung",
      privacy: "Datenschutz",
      retailer: "Händler werden",
    },
    legal: {
      terms: "Allgemeine Geschäftsbedingungen",
      imprint: "Impressum",
      cookies: "Cookies",
      privacy: "Datenschutzrichtlinie",
    },
    copyright: "&copy; Happy Plants™ 2025",
    developedBy: "Webdesign und Entwicklung von Amark.pro",
  },

  // Common texts
  common: {
    readNow: "Jetzt lesen",
    readMore: "Mehr lesen",
    learnMore: "Mehr erfahren",
    buyNow: "Jetzt kaufen",
    addToCart: "In den Warenkorb",
    shop: "Shop",
    shopNow: "Jetzt kaufen",
    explore: "Erkunden",
  },
};